var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLensProtect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 0H22C19.672 0 17 2.728 17 24C17 45.272 19.672 48 22 48H26C28.328 48 31 45.272 31 24C31 2.728 28.328 0 26 0ZM19 24C19 2.25 21.877 2 22 2H23.388C22.04 4.676 21 10.729 21 24C21 37.271 22.04 43.324 23.388 46H22C21.877 46 19 45.75 19 24ZM26 46C25.877 46 23 45.75 23 24C23 2.25 25.877 2 26 2C26.123 2 29 2.25 29 24C29 45.75 26.123 46 26 46Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLensProtect);
export default __webpack_public_path__ + "static/media/lens-protect.70f7c6c9b85167990d34089ccf5a93b2.svg";
export { ForwardRef as ReactComponent };